import { render, staticRenderFns } from "./uploadcobmit.vue?vue&type=template&id=d6583902&scoped=true&"
import script from "./uploadcobmit.vue?vue&type=script&lang=js&"
export * from "./uploadcobmit.vue?vue&type=script&lang=js&"
import style0 from "./uploadcobmit.vue?vue&type=style&index=0&id=d6583902&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6583902",
  null
  
)

export default component.exports